import { OneTrustInterface } from '@legacy-ntg/components/one-trust.js';
import { ThirdPartyNotification } from '@legacy-ntg/components/third-party-notification.js';
import { VideosEditorial } from '../../legacy-vue/shared/scripts/videos-editorial.js';
import LinkHandler from './kiosk-mode.js';
import Anchor from './../../legacy-vue/shared/scripts/anchor.js';

(() => {
  // Init third party notification
  window.thirdPartyNotification = new ThirdPartyNotification({
    ids: ['vimeo'],
  });

  new OneTrustInterface({
    thirdParty: window.thirdPartyNotification,
  });

  // Videos
  new VideosEditorial({
    parent: '.vimeo-video--atmo',
    allowMultiPlay: true,
  });
  new VideosEditorial({
    parent: 'man-stage',
    allowMultiPlay: true,
  });
  new VideosEditorial({
    parent: 'man-offers-and-promotions',
  });
  new VideosEditorial(); // captures .editorial-content vimeo videos

  const params = new URLSearchParams(window.location.search);
  if (params.get('kioskMode') === 'true') {
    new LinkHandler();
  }

  new Anchor();
})();
